<!--
预览提现&提现 底部弹窗
e.g.

    <withDrawActionSheet
      v-model="bottomSheetVisible"
      :isPreview="true"
      @onTopAction="onTopAction"
      @onBuyAction="onBuyAction"
      @onProtocolAction="onProtocolAction"
    >
    </withDrawActionSheet>

-->
<template>
  <action-sheet v-model="show" :close-on-click-overlay="false">
    <div class="top-action" :class="{'isWithDraw': !isPreview}" @click="onTopAction">{{ isPreview ? '直接提现 >' : '放弃免审，并回到首页 >'}}</div>
    <div class="content" :class="{hasCoupon}">
      <div class="top-title">{{ isPreview ? '每日额度有限' : '审核通道已满' }}</div>
      <div class="wrap">
        <div class="title">
          <div v-if="isPreview">推荐<span class="yellow">免审通道</span>极速下款</div>
          <div v-else>已为你预充值免审额度<span class="yellow">{{ amount }}元</span></div>
        </div>
        <div class="choice">
          —— <span class="yellow">95%</span>用户选择免审通道下款成功 ——
        </div>
        <div class="pass-rate card">
          <div class="left">
            <div class="title">极速通过</div>
            <div class="desc">平台审核通过率<span class="red">100%</span></div>
          </div>
          <img src="../image/img_result_clean_pass_banner_trailing.png">
        </div>
        <div class="card-group">
          <div class="card">
            <div class="title">优先放款</div>
            <div class="desc">优先匹配资方</div>
          </div>
          <div class="card">
            <div class="title">赔付特权</div>
            <div class="desc">被拒2-7个工作日自动退</div>
          </div>
        </div>
        <!-- 优惠券信息 -->
        <coupon-info
          v-if="hasCoupon"
          class="dialog-coupon-info"
          :couponDiscountValue="20"
          :useEndTime="1689152960224"
        />

        <div class="buy-button" @click="buyButtonAction" data-sensors-click>

          <span class="ui-bubble" v-if="expireDate && (expireDate - new Date().getTime() >0) && !hasCoupon">
            <van-count-down
              :time="expireDate - new Date().getTime()"
              format="DD天HH时mm分"
            />后涨价
          </span>

          <div class="real-price">
            限时优惠价 ¥{{ discountPrice }}
          </div>
          <div class="origin-price">
            原价 ¥{{ originalPrice }}
          </div>
        </div>
        <div class="protocol">
          开通即同意<span @click="protocolAction">《会员用户协议》</span>
        </div>
      </div>
    </div>
  </action-sheet>
</template>

<script>
import { ActionSheet } from 'vant'
import { mapActions } from 'vuex'
import { WHPay } from '@/assets/buyVip'
export default {
  components: {
    ActionSheet,
    'coupon-info': () => import('@/components/coupon-info/index.vue')
  },
  data () {
    return {
      amount: 0, // 免审额度，仅在非预览提现页面(isPreview=false)展示时有效
      discountPrice: 0, // 优惠价格
      originalPrice: 0, // 原价
      expireDate: new Date().getTime() + 1000 * 60 * 60 * 24 * 3 // 优惠券过期时间
    }
  },
  props: {
    // 是否是预览弹窗，默认true
    isPreview: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },

  async mounted () {
    if (!this.isPreview) {
      const response = await this.getFloatViewInfo({
        showPlace: 'HOME'
      })
      if (response.success) {
        const { passCardFloatBean } = response.data
        this.amount = passCardFloatBean.passLimitAmount
      }
    }
    const bizTagRes = await this.getBizTag()
    if (bizTagRes.success && bizTagRes.data.passCardTag === 'HAVE_QUALIFICATION') {
      const res = await this.memberShipDetail({
        memberGoods: 'PSC_M'
      })
      if (res.success) {
        this.discountPrice = res.data.memberGoods.discountPrice || 0
        this.originalPrice = res.data.memberGoods.price || 0
      }
    }
  },
  methods: {
    ...mapActions('user', ['getFloatViewInfo', 'getBizTag']),
    ...mapActions('vip', ['memberShipDetail']),
    // 点击顶部按钮事件
    onTopAction () {
      this.$emit('onTopAction')
    },
    // 点击购买按钮事件
    buyButtonAction () {
      WHPay(this.isPreview)
    },
    // 点击协议事件
    protocolAction () {
      this.$router.push('/protocol/vip-wh')
    }
  },
  computed: {
    hasCoupon () {
      return !true
    },
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.van-popup {
  background: transparent;
}
.top-action {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 33px;
  position: relative;
  left: 601px;
  margin-bottom: 55px;
  &.isWithDraw {
    left: 457px;
  }
}
.content {
  height: 725px;
  background: linear-gradient(90deg, #FF8537 0%, #ED4040 100%);
  border-radius: 30px 30px 0px 0px;
  padding: 10px 0;

  &.hasCoupon {
    .dialog-coupon-info {
      top:600px;
      height: 90px;
      width: 650px;
    }
    .buy-button {
      margin-top: 70px;
    }
  }
  .top-title {
    background: url(../image/withdraw-action-sheet-title-bg.png) no-repeat center center;
    background-size: cover;
    width: 384px;
    height: 64px;
    margin: 0 auto;
    text-align: center;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #763E12;
    line-height: 64px;
    margin-top: -19px;
  }
  .yellow {
    color: #FFF79B;
  }
  .red {
    color: #FF4633;
  }
  .card {
    background: #FFFFFF;
    border-radius: 20px;
    .title {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 50px;
      margin: 0;
    }
    .desc {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 33px;
      width: 1120%;
    }
  }
  .wrap {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .title {
      font-size: 48px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 67px;
      margin-top: 30px;
    }
    .choice {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 33px;
      margin-top: 10px;
    }
    .pass-rate {
      width: 650px;
      height: 132px;
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 0 0 30px;
      .left {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .title {
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 50px;
          margin: 0;
        }
      }
      img {
        width: 125px;
        height: 78px;
      }
    }
    .card-group {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 20px;
      height: 128px;
      width: 650px;
      .card {
        width: 315px;
        padding: 23px 30px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .title {
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 50px;
          margin: 0;
        }
        .desc {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 33px;
        }
      }
    }
  }
  .buy-button {
    width: 650px;
    height: 88px;
    background: linear-gradient(90deg, #FFEB82 0%, #FFD450 100%);
    border-radius: 47px;
    margin-top: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    .ui-bubble {
      background:  rgba(0,0,0,0.8);;
      border-radius: 20px 20px 20px 0px;
      color: #fff;
      font-size: 20px;
      padding: 4px 20px;
      position: absolute;
      left: 44%;
      top: -20px;
      display: flex;
      height: 44px;
      align-items: center;
      .van-count-down {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffd8bc;
        line-height: 33px;
      }
    }
    .real-price {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #7F3800;
      line-height: 45px;
      margin-right: 24px;
    }
    .origin-price {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      opacity: 0.6;
      color: #7F3800;
      line-height: 34px;
      text-decoration: line-through;
    }
  }
  .protocol {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 33px;
    margin-top: 20px;
    span {
      text-decoration: underline;
    }
  }
}
</style>